import { WhatsAppSession } from '@/types/whatsApp'
import { api } from '@/utils/api'
import { apiWhatsappsSessions } from '@/utils/api/url'
import { useQuery } from '@tanstack/react-query'

export const QUERY_KEY_GET_WA_SESSIONS = 'QUERY_KEY_GET_WA_SESSIONS'

export const useGetWaSessions = ({ enabled = true }: { enabled?: boolean }) => {
  const res = useQuery({
    enabled: enabled,
    queryKey: [QUERY_KEY_GET_WA_SESSIONS],
    queryFn: () =>
      api
        .get(apiWhatsappsSessions)
        .then(({ data }) => data as WhatsAppSession[]),
  })
  return res
}
